<template>
    <v-app>
      <v-dialog
        v-model="lang_dialog"
        persistent
        scrollable
      >
          <v-card>
              <v-card-title style="display:block">กรุณาเลือกภาษาของคุณ</v-card-title>
              <v-card-subtitle>Please select your language</v-card-subtitle>
              <v-divider></v-divider>
              <v-card-text align="center">
                <div class="mt-8">
                <v-btn
                  color="primary"
                  rounded
                  x-large
                  @click="selectLang('th')"
                >
                  ภาษาไทย
                </v-btn>
                </div>
                <div class="mt-4">
                <v-btn
                  color="primary"
                  rounded
                  x-large
                  @click="selectLang('en')"
                >
                  English
                </v-btn>
                </div>
              </v-card-text>
          </v-card>
      </v-dialog>

    </v-app>
</template>

<script>
import axios from 'axios';
import config from '@/../config.js'
import App from '@/models/instance/App'
import Member from '@/models/instance/Member'


export default {
  data () {
    return {
      lang_dialog:false
    }
  },
  mounted : function () {
    

    if(this.$route.friendship_status_changed!=undefined && this.$route.friendship_status_changed == false){
      location.replace(App.getAppConfigAddFriendUrl())
    }else{
      var data = {
          app_id:App.getAppId()
          ,code:this.$route.query.code
      }

      var endpos = 0;
      if(this.$route.fullPath.indexOf('&friendship_status_changed=')>0 && (endpos == 0 || this.$route.fullPath.indexOf('&friendship_status_changed=') < endpos)){
        endpos = this.$route.fullPath.indexOf('&friendship_status_changed=')
      }
      if(this.$route.fullPath.indexOf('&liff=')>0 && (endpos == 0 || this.$route.fullPath.indexOf('&liff=') < endpos)){
        endpos = this.$route.fullPath.indexOf('&liff=')
      }
      if(this.$route.fullPath.indexOf('&code=')>0 && (endpos == 0 || this.$route.fullPath.indexOf('&code=') < endpos)){
        endpos = this.$route.fullPath.indexOf('&code=')
      }
      if(this.$route.fullPath.indexOf('&state=')>0 && (endpos == 0 || this.$route.fullPath.indexOf('&state=') < endpos)){
        endpos = this.$route.fullPath.indexOf('&state=')
      }

      data['uri'] = window.location.origin + this.$route.fullPath.substring(0,endpos)
      

      var que = this.$store.commit('addLoading')
      axios.post(config.api.url.public.line.login,data).then(response => {
          this.$store.commit('finishLoading',que)
          if(!response.data.friendFlag){
            //location.replace(App.getAppConfigAddFriendUrl())
          }else if(response.data.isSuccess){
            Member.setToken(response.data.token)
            if(response.data.is_firsttime){
              this.lang_dialog = true
            }else{
              Member.setLang(response.data.lang)
              this.$router.push(this.$route.query.redirect_uri)
            }

          }else{
            this.$router.push({name:'Error',params:response.data}) 
          }
      }).catch(error => {
        this.$router.push({name:'Error',params:error}) 
      })
    }
    

  }
  ,
  methods : {
    selectLang(lang){
      var que = this.$store.commit('addLoading')
      axios.post(config.api.url.public.line.register,{ lang : lang , app_id:App.getAppId() },{ headers: Member.getTokenHeader()})
      .then(response2=>{
        this.$store.commit('finishLoading',que)
        Member.setToken(response2.data.token)
        Member.setLang(response2.data.lang)
        this.$router.push(this.$route.query.redirect_uri)
      })
    }
  }
}
</script>